import { CustomSxProps, UI_KIT } from "../../theme";

export const personalAreaWrapper: CustomSxProps = {
	dispay: "block",
};

export const personalAreaWrapper__title: CustomSxProps = {
	paddingBottom: UI_KIT.p16,
};

export const userDataWrapper: CustomSxProps = {
	padding: UI_KIT.p16,
	display: "flex",
	flexDirection: "column",
	alignItems: "flex-start",
	justifyContent: "flex-start",
	gap: UI_KIT.p8,
};

export const favoritesWrapper: CustomSxProps = {
	paddingBottomgB: UI_KIT.p32,
};
